module.exports = __webpack_public_path__ + "34736292/img/pwrd-by-sourcery-black.bba9ba41.svg";